import useSWR from 'hooks/useSWR';

export default id =>
  useSWR({
    url: `/v1/rpp_credit_transfers/${id}`,
    swrOptions: { if: Boolean(id) }
  });
